import { createContext } from "react";
import { RowContract } from "../../components/organisms/TableTour";
export type ConsultaTourPasseio = {
  destino: string;
  barco: string;
  dataInicial: Date | string;
  dataFinal: Date | string;
  data: RowContract[];
  jaConsultou: boolean;
};
export type ConsultaTourContextType = {
  passeio: ConsultaTourPasseio;
  setPasseio: React.Dispatch<React.SetStateAction<ConsultaTourPasseio>>;
};

export const consultaTourDefault = {
  destino: "0",
  barco: "0",
  dataInicial: "",
  dataFinal: "",
  data: [],
  jaConsultou: false,
};

export const ConsultaTourContext = createContext<ConsultaTourContextType>(
  null!
);
